import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../models/api-response';
import { LicenceReminderSetting } from '../../models/licence-reminder-setting';

@Injectable({ providedIn: 'root' })
export class LicenceRemindersService {
  constructor(private http: HttpClient) {}

  getSetting(organizationId: string): Observable<ApiResponse<LicenceReminderSetting>> {
    return this.http.get<ApiResponse<LicenceReminderSetting>>(
      `${environment.apiBaseUrl}/admin/organizations/${organizationId}/licence-reminders`
    );
  }

  updateSetting(
    organizationId: string,
    request: {
      isEnabled: boolean;
      reminderDaysBeforeExpiry: string;
    }
  ) {
    return this.http.put<ApiResponse<LicenceReminderSetting>>(
      `${environment.apiBaseUrl}/admin/organizations/${organizationId}/licence-reminders`,
      request
    );
  }
}